import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import "components/Tribe/Friends/FriendsHome/FriendListContainer.css";
import ProfilePic from "components/General/ProfilePic";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import * as CONSTANT from "constants/text";
import "components/Tribe/Friends/UserDetail/FriendUserProfileBox.css";
import MemberSettings from "components/Tribe/Groups/GroupProfile/MemberSettings";
import Popover from "react-bootstrap/Popover";

function GroupCell(props) {
  return (
    <div className="my_friend_container">
      {props.userRole === CONSTANT.OWNER ? (
        <div className="member_settings">
          <MemberSettings
            role={props.role}
            name={props.name}
            groupId={props.groupId}
          />
        </div>
      ) : null}
      <div className="my_friend_card" onClick={props.buttonAction}>
        <div className="my_friend_card_column_main">
          <div className="my_friend_profile_pic">
            <ProfilePic
              profilePic={props.groupPic}
              className="friend_card_profile_pic"
              type={props.friendsPic ? CONSTANT.FRIENDS : CONSTANT.GROUPS}
            />
          </div>

          <div className="my_friend_card_detail_rows">
            <div></div>
            <div className="friend_details_username">
              <TextTheme
                message={props.name}
                className={"text_medium text_semi_bold text_dark_blue break-text"}
              />
            </div>
            <div className="friend_details_date">
              <TextTheme
                message={props.dateMessage + formatDate(props.date)}
                className={"text_xsmall text_med_grey"}
              />
            </div>
            {props.type === CONSTANT.INVITATIONS && props.inviter_username ? (
              <div className="name_container">
                <div className="float">
                  <TextTheme
                    message={CONSTANT.FROM + props.inviter_username}
                    className={"text_xxsmall text_med_grey"}
                  />
                </div>
                {props.inviteList && props.inviteList.length > 0 ? (
                  <div className="float">{renderInvites(props.inviteList)}</div>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

// time comes in format "2020-10-27" and leaves as "10-27-2020"
function formatDate(date) {
  //remove all hour-minute-second info
  var splitString = date.split("-");
  var newDate = splitString[1] + "/" + splitString[2] + "/" + splitString[0];
  return newDate;
}

function renderInvites(inviteList) {
  if (inviteList.length === 1) {
    return null;
  } else if (inviteList.length === 2) {
    return (
      <TextTheme
        message={" and " + inviteList[1]}
        className={"text_xxsmall text_med_grey"}
      />
    );
  } else {
    return (
      <OverlayTrigger
        trigger="hover"
        overlay={
          <Popover id="popover-contained">
            <Popover.Content>{inviteList.slice(1).join(", ")}</Popover.Content>
          </Popover>
        }
      >
        <p className="invite_text"> and {inviteList.length - 1} others</p>
      </OverlayTrigger>
    );
  }
}

export default GroupCell;
